import script from "./install-agent.vue?vue&type=script&setup=true&lang=ts"
export * from "./install-agent.vue?vue&type=script&setup=true&lang=ts"

import "./install-agent.vue?vue&type=style&index=0&id=6cb84052&lang=css&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cb84052"]])

export default __exports__